<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6" v-if=" !userInfo.thirdAccount && !hiddenQueryItems.includes('corpId')" >
            <a-form-item label="用水企业">
              <j-search-select-tag
                @change="corpChange"
                dict="`iwt-wf`.wf_consumer_corp,corp_name,id, 1=1 order by corp_name asc"
                placeholder="请选择用水企业"
                v-model="queryParam.corpId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6" >
            <a-form-item label="取水人">
              <j-search-select-tag
                @change="searchQuery"
                :dictOptions="consUserOptions"
                placeholder="请选择取水人"
                v-model="queryParam.consumerUserId"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="违规类型">
                <j-dict-select-tag dictCode="	wf_violations_type" placeholder="请选择违规类型" type="list" v-model="queryParam.violationsType" />
              </a-form-item>
            </a-col>
            <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="违规时间">
                <j-date placeholder="请选择违规时间" v-model="queryParam.violationsTime"></j-date>
              </a-form-item>
            </a-col> -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('违规事件')">导出</a-button>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
        </span>

      </a-table>
    </div>

    <wf-violations-modal ref="modalForm" @ok="modalFormOk"></wf-violations-modal>
  </a-card>
</template>

<script>
  import { getAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WfViolationsModal from './modules/WfViolationsModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'WfViolationsList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      WfViolationsModal
    },
    props: {
      //表单禁用
      filter: {
        type: Object,
        default: () => { },
      }
    },
    watch: {
      filter: {
        handler () {
          this.searchQuery();
        },
        deep: true
      }
    },
    data () {
      return {
        description: '加水机违规事件管理页面',
        isorter: {
          column: 'violationsTime',
          order: 'desc',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'设备',
            align:"center",
            sorter: true,
            dataIndex: 'devId_dictText'
          },
          {
            title:'取水人',
            align:"center",
            sorter: true,
            dataIndex: 'consumerUserId_dictText'
          },
          {
            title:'用水企业',
            align:"center",
            sorter: true,
            dataIndex: 'corpId_dictText'
          },
          {
            title:'违规类型',
            align:"center",
            sorter: true,
            dataIndex: 'violationsType_dictText'
          },
          {
            title:'违规时间',
            align:"center",
            sorter: true,
            dataIndex: 'violationsTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'次数',
            align:"center",
            dataIndex: 'count'
          },
          {
            title:'是否处理',
            align:"center",
            dataIndex: 'dealflag',
            customRender: (text) => (text ? filterMultiDictText(this.dictOptions['dealflag'], text) : ''),
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/wf/violations/list",
          delete: "/wf/violations/delete",
          deleteBatch: "/wf/violations/deleteBatch",
          exportXlsUrl: "/wf/violations/exportXls",
          importExcelUrl: "wf/violations/importExcel",
          corpUserList: "/custom/user/list",
        },
        localFilter: {},
        dictOptions:{},
        consUserOptions: [],
        superFieldList:[],
      }
    },
    created() {
      this.$set(this.dictOptions, 'dealflag', [{text:'是',value:'Y'},{text:'否',value:'N'}])
      this.getSuperFieldList();

      //如果是企业管理员登录，赋值corpId, 值为userInfo.corpIds
      if(!!this.userInfo.thirdAccount){
        this.localFilter = {
          corpId: this.userInfo.corpIds
        }
      }

      if (this.filter?.corpId || this.localFilter?.corpId) {
        this.columns = this.columns.filter(col => col.dataIndex !== 'corpId_dictText')
        //写入queryParam，查询和导出都增加过滤条件
        this.queryParam.corpId = this.queryParam.corpId = this.filter?.corpId || this.localFilter?.corpId;
      }

      // 在 localFilter 设置完成后调用 loadData
      this.$nextTick(() => {
        this.loadData(1);
      });
      this.getConsUser();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      hiddenQueryItems () {
        return this.filter ? Object.keys(this.filter) : [];
      },
      userInfo() {
        return this.$store.getters.userInfo
      }
    },
    methods: {
      loadData (arg) {
        if (!this.url.list) {
          this.$message.error('请设置url.list属性!')
          return
        }
        // 加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1
        }
        var params = this.getQueryParams()// 查询条件
        this.loading = true;
        // 合并 localFilter 和 filter
        const mergedFilter = { ...this.localFilter, ...this.filter };
        Object.assign(params, mergedFilter);

        console.log('loadData params:', params); // 添加日志以检查参数
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records || res.result
            if (res.result.total) {
              this.ipagination.total = res.result.total
            } else {
              this.ipagination.total = 0
            }
          }
        }).finally(() => {
          this.loading = false
        })
      },
      corpChange(){
        this.queryParam.consumerUserId = null;
        this.searchQuery();
        this.getConsUser();
      },
      getConsUser(){
        this.consUserOptions =[];
        const params = { 
          pageSize: 999999,
          corpId: this.queryParam.corpId
         };
        getAction(this.url.corpUserList, params).then((res) => {
          if (res.success) {
            res.result.records.forEach(user => {
              this.consUserOptions.push({
                value: user.id,
                text: user.nickname
              });
            });
          } else {
            this.$message.error(res.message)
          }
        })
      },
      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'devId',text:'设备',dictCode:'`iwt-wf`.dev_list,dev_name,id'})
        fieldList.push({type:'string',value:'consumerUserId',text:'取水人',dictCode:'`iwt-wf`.wf_consumer_user,nickname,id'})
        fieldList.push({type:'string',value:'corpId',text:'用水企业',dictCode:'`iwt-wf`.wf_consumer_corp,corp_name,id'})
        fieldList.push({type:'string',value:'violationsType',text:'违规类型',dictCode:''})
        fieldList.push({type:'date',value:'violationsTime',text:'违规时间'})
        fieldList.push({type:'int',value:'count',text:'次数',dictCode:''})
        fieldList.push({type:'switch',value:'dealflag',text:'是否处理'})
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>